"use client";
import React, { useRef, useState } from 'react';

interface TemplateCssDialogProps {
  title: string;
  onClose: () => void;
  onSave: (css: string) => void;
  initialCss: string;
}

const TemplateCssDialog: React.FC<TemplateCssDialogProps> = ({ title, onClose, onSave, initialCss }) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  const [css, setCss] = useState(initialCss);

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
      onClose();
    }
  };

  const handleSave = () => {
    onSave(css);
  };

  return (
    <div
      className="fixed inset-0 bg-gray-600/50 overflow-y-auto h-full w-full flex items-center justify-center"
      onClick={handleBackdropClick}
    >
      <div ref={dialogRef} className="bg-white p-5 rounded-lg w-3/5">
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <textarea
          className="w-full h-64 p-2 border border-solid border-gray-300 rounded"
          value={css}
          onChange={(e) => setCss(e.target.value)}
          placeholder="Enter your CSS here..."
        />
        <div className="flex justify-end mt-4">
          <button onClick={onClose} className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2">
            Cancel
          </button>
          <button onClick={handleSave} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCssDialog;
